<template>
  <div class="books">
    <RwvBookTable></RwvBookTable>
  </div>
</template>

<script>
import RwvBookTable from '@/components/Books/BookTable.vue'

export default {
  title: "Bücher | So wird's gemacht",
  name: 'Home',
  components: {
    RwvBookTable
  }
}
</script>

<style>
</style>
